// Import of actions
import * as NewsActions from "../actions/news.actions";
import { IDiaprofilNews } from "../../models/types";

export type NewsState = IDiaprofilNews[];

export const initialState: IDiaprofilNews[] = [];

export function newsReducer(
  state = initialState,
  action: NewsActions.Actions
): NewsState {
  switch (action.type) {
    case NewsActions.RESET_STATE: {
      return initialState;
    }

    case NewsActions.ADD: {
      return state.find(item => item.id === action.payload.id)
        ? state
        : [...state, action.payload];
    }

    case NewsActions.REPLACE: {
      return [
        ...state.filter(item => item.id !== action.payload.id),
        action.payload // payload is FHIR resource
      ];
    }

    case NewsActions.UPDATE: {
      return state.map(item => {
        return item.id === action.payload.id
          ? { ...item, ...action.payload }
          : item;
      });
    }

    case NewsActions.DELETE: {
      return state.filter(item => item.id !== action.payload.id);
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/news.reducer.ts